import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import classnames from 'classnames';
import Tabs from "../../Components/Tabs/Tabs";
import DependencyManager from "../../DependencyManager";
var css = {
  "cardContainer": "oalp-3NS9A",
  "mobile": "oalp-2c6DE",
  "requiredtab": "oalp-3Sx9G"
};
import { compose } from 'redux';
import { withRouter } from "../../Helpers/withRouter";
import ListContainer from "../ListContainer/ListContainer";
var TabContent = function TabContent(_ref) {
  var content = _ref.content;
  var PanameraConstants = DependencyManager.getDependency('constants');
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(css.cardContainer, css[PanameraConstants.platform])
  }, content === null || content === void 0 ? void 0 : content.card.map(function (data) {
    return /*#__PURE__*/React.createElement(ListContainer, {
      list: data.list,
      title: data.title
    });
  }));
};
export var TabsCardComponent = function TabsCardComponent(_ref2) {
  var data = _ref2.data,
    metadata = _ref2.metadata;
  var _ref3 = metadata || {},
    style = _ref3.style;
  var tabs = data.tabs;
  var tabsData = tabs.map(function (item) {
    var tab = {
      title: item.tabTitle,
      key: item.tabTitle,
      defaulTitleMessage: item.tabTitle
    };
    return tab;
  });
  var PanameraConstants = DependencyManager.getDependency('constants');
  var _useState = useState(tabs[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useState3 = useState(tabs[0].widgetData),
    _useState4 = _slicedToArray(_useState3, 2),
    selectTabContent = _useState4[0],
    setSelectTabContent = _useState4[1];
  function handleTabClick(tab) {
    var newSelectedTab = tabs.find(function (a) {
      return a.tabTitle === tab.key;
    });
    if (newSelectedTab) {
      setSelectedTab(newSelectedTab);
      setSelectTabContent(newSelectedTab.widgetData);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(Tabs, {
    tabsData: tabsData,
    selectedTab: selectedTab.tabTitle,
    onTabClick: handleTabClick,
    tabsClassName: classnames(css.requiredtab, css[PanameraConstants.platform])
  }), /*#__PURE__*/React.createElement(TabContent, {
    content: selectTabContent
  })));
};
export default compose(withRouter)(TabsCardComponent);